import React, { Component } from 'react';
import { connect } from 'react-redux'
import {reduxForm, formValueSelector, change} from 'redux-form';
require(`../assets/${process.env.PAGE}/css/components/Contracts.css`)
import { Row, Col } from 'react-bootstrap';
import {FormattedHTMLMessage} from 'react-intl';
import CustomSpinner from './CustomSpinner';
import ContractContainer from '../containers/ContractContainer.js';
import axios from "axios";

class Contracts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contracts: []
        };
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        axios.get(`${ROOT_URL}/leads/contracts`, config)
            .then((response) => {
                this.setState({
                    contracts: response.data.contracts
                });
            });
    }

    getContracts = () => {
        let contractsForm = [];
        const {myContracts} = this.props;

        for (let index in this.state.contracts){
            let accepted = false;
            let name = this.state.contracts[index].contract_type;
            let label = this.state.contracts[index].title;

            if (name in myContracts){
                accepted = myContracts[name].values.contract_accepted;
            }

            let contract = <ContractContainer key={index} form={name} onSubmit={this.props.submitContract}
                                              checked={accepted} label={label} />
            contractsForm.push(contract);
        }

        return contractsForm;
    }

    render() {
        const { handleSubmit, acceptedAllContracts } = this.props;

        let contractsForm = this.getContracts();
        return (
            <div className="terms text-center">
                <form onSubmit={handleSubmit(this.props.getStep)}>
                {this.props.isLoading &&  <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                    <h3>Consentimiento Legal</h3>
                    <FormattedHTMLMessage id="app.contract_advice" defaultMessage="<p>Por favor, abrir, leer y acordar.</p>" description="Advice"/>
                    {contractsForm}
                    <Row className="terms_row">
                        <Col className="terms_col text-center" xs={12} md={12} lg={12}>
                            <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={!acceptedAllContracts} >Finalizar</button>
                        </Col>
                    </Row>
                 </form>
            </div>
        );
    }
}

Contracts = connect(
    state => ({
        myContracts: state.form,
        acceptedAllContracts: Object.values(state.form).filter(x => (x.values ? x.values.contract_accepted === false : false)).length === 0
    }),
)(Contracts)

Contracts = reduxForm({
    form: 'Contracts', // a unique name for this form
})(Contracts);

export default Contracts;



/** WEBPACK FOOTER **
 ** ./src/components/Contracts.js
 **/